export const pageData = {
	imgUrl : "/assets/images/usersImage/28.jpg",
	userName:"Naveen",
	companyName:"Apoorva Traders",
	companyEmail:"apoorva.traders2011@gmail.com",
	developerEmail:"naveenkamal.2011@gmail.com",
	primaryContact : "+91-9431253247",
	secondaryContact : "+91-7004505859",
	visitorsCount : "10000",
	lastUpdate : "22-JAN-2022",
}

export default pageData;